import { Field, Form, Formik } from 'formik';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import RadioButton from '@perpay-web/components/base/RadioButton/RadioButton';

import styles from './EmailMisspelledModal.scss';

const EmailMisspelledModal = ({
    onClose,
    className = '',
    original,
    suggestions,
    onChoosingSuggestedEmail,
}) => (
    <Modal
        onClose={onClose}
        className={styles.center}
        containerClassName={className}
    >
        <div className={styles.container}>
            <div className={styles.title}>Did you mean?</div>
            <Formik
                initialValues={{ email: suggestions[0].corrected }}
                onSubmit={(values) => {
                    onChoosingSuggestedEmail(values.email);
                    onClose();
                }}
            >
                {({ setFieldValue, handleSubmit }) => (
                    <Form>
                        <div className={styles.choice}>You Entered:</div>
                        <Field
                            name='email'
                            component={RadioButton}
                            radioValue={original}
                            setFieldValue={setFieldValue}
                            className={styles.radio}
                        >
                            <div className={styles['radio-content']}>
                                {original}
                            </div>
                        </Field>
                        <div className={styles.choice}>Suggested Emails:</div>
                        {suggestions.length
                            ? suggestions.map(({ corrected }) => (
                                  <Field
                                      name='email'
                                      component={RadioButton}
                                      key={corrected}
                                      radioValue={corrected}
                                      setFieldValue={setFieldValue}
                                      className={styles.radio}
                                  >
                                      <div className={styles['radio-content']}>
                                          {corrected}
                                      </div>
                                  </Field>
                              ))
                            : null}
                        <div className={styles.buttons}>
                            <CustomButton action='secondary' onClick={onClose}>
                                Edit Email
                            </CustomButton>
                            <CustomButton
                                action='primary'
                                onClick={handleSubmit}
                                type='submit'
                            >
                                Continue
                            </CustomButton>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </Modal>
);

export default EmailMisspelledModal;
